import type { ApiWorkflowWithUsages } from '@jira/project-settings__project-configuration-commons';

const TRIGGER_AGENT_RULE_KEY = 'system:trigger-agent';

/**
 * Do not use, temporary hook to be cleaned up post Team EU 25
 * Retrieves the agentId from a workflow transition rule with the trigger agent rule key.
 * Returns null if not found or if input is invalid.
 */
export const getAgentIdFromTransitionRule = ({
	transitionId,
	workflow,
}: {
	transitionId: string | null;
	workflow: ApiWorkflowWithUsages | null;
}): string | null => {
	if (!workflow || !transitionId) {
		return null;
	}

	const transitions = workflow.transitions ?? [];
	const transition = transitions.find((t) => t?.toStatusReference === transitionId);
	if (!transition || !Array.isArray(transition.actions)) {
		return null;
	}

	const action = transition.actions.find(
		(a: { ruleKey?: string }) => a?.ruleKey === TRIGGER_AGENT_RULE_KEY,
	);

	return action?.parameters?.agentId ?? null;
};
